import AppConstants from '../config/app.constants';

let BranchFundingSourceHolidayService = function ($http, $q) {

    let all = (search, branchId, offset, limit) => {
        return $http
            .get(AppConstants.api + `/branch-funding-source-holiday`, {
                params: {
                    search,
                    branchId,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/branch-funding-source-holiday/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/branch-funding-source-holiday/${id}/update`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/branch-funding-source-holiday/${id}/detail`)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchFundingSourceId, branchId) => {
        return $http
            .delete(AppConstants.api + `/branch-funding-source-holiday/${id}/delete`, {
                params: {
                    branchId,
                    branchFundingSourceId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get
    };
};

BranchFundingSourceHolidayService.$inject = ['$http', '$q']

export default BranchFundingSourceHolidayService;


// WEBPACK FOOTER //
// ./client/app/services/branch-funding-source-holiday.service.js